import React, { useEffect, useMemo, useLayoutEffect, useState } from "react";
import { GetAddress, GetAccount, GetAccounts, GetSharesWithServiceProvider, GetServiceProvider, getInfo, GetBeneficiary, GetSharedSecuredContent, GetSharesWith, GetTemplatesByServiceProviderID, GetTemplateByID, GetRequestDetails, GetSharedStream } from "../utilities/calls";
import Login from "./Login";
import ContentBox from "./SecuredContentBox";
import AddressBox from "./AddressBox";
import { FirstMatchedTemplate,ProcessTemplate } from "../utilities/templates";
import StreamBox from "./StreamBox";
import { matchesFilters } from "../utilities/shareFilters";
import ShareFiltersBar from "./ShareFiltersBar";
 
const ServiceProviderShares = () => {
    const [addresses, setAddresses] = useState([]);
    const [shares, setShares] = useState({});
    const [requests, setRequests] = useState({});
    const [sharesBen, setSharesBen] = useState({});
    const [userId, setUserId] = useState();
    const [showAlert, setShowAlert] = useState();
    const [alertText, setAlertText] = useState();
    const [serviceProviderList, setServiceProviderList] = useState({});
    const [beneficiaryList, setBeneficiaryList] = useState([]);
    const [securedContents, setSecuredContents] = useState([]);
    const [streams, setStreams] = useState([]);
    const [state, setState] = useState(0);
    const [refBenAcceptedSpIds, setRefBenAcceptedSpIds] = useState([]);
    const spIds = useState([]);
    const [filters, setFilters] = useState({
        contentType: "",
        searchText: "",
        sharedWith: [],
        sharedWithText: "",
    });
    const [groupBySP, setGroupBySP] = useState(() => {
        try {
            const saved = localStorage.getItem(
                document.location.hostname + '.shares.groupBySP'
            );
            const parsed = saved ? JSON.parse(saved) : {};
            return typeof parsed === "object" && parsed !== null ? parsed : {};
        } catch (e) {
            console.error("Failed to parse groupBySP from localStorage", e);
            return {};
        }
    });
    const [groupByBen, setGroupByBen] = useState(() => {
        try {
            const saved = localStorage.getItem(
                document.location.hostname + '.shares.groupByBen'
            );
            const parsed = saved ? JSON.parse(saved) : {};
            return typeof parsed === "object" && parsed !== null ? parsed : {};
        } catch (e) {
            console.error("Failed to parse groupByBen from localStorage", e);
            return {};
        }
    });
    const contentMap = useMemo(() => {
        const map = {};
        securedContents.forEach(c => {
            if (c?.id) map[c.id] = c;
        });
        return map;
    }, [securedContents]);

    const streamMap = useMemo(() => {
        const map = {};
        streams.forEach(s => {
            if (s?.ID) map[s.ID] = s;
        });
        return map;
    }, [streams]);

    const addressMap = useMemo(() => {
        const map = {};
        addresses.forEach(a => {
            if (a?.id) map[a.id] = a;
        });
        return map;
    }, [addresses]);

    const beneficiaryMap = useMemo(() => {
        const map = {};
        beneficiaryList.forEach(b => {
            if (b?.id) map[b.id] = b;
        });
        return map;
    }, [beneficiaryList]);
    const refBenSet = useMemo(() => {
    return new Set(refBenAcceptedSpIds);
    }, [refBenAcceptedSpIds]);

    const [sharedWithInput, setSharedWithInput] = useState("");
    const [sharedWithSuggestions, setSharedWithSuggestions] = useState([]);

    const [templates, setTemplates] = useState([{id: "0", Name: "Documents", Tags: { "DisplayName": {
        "Name": "DisplayName",
        "Value": "Documents",
        "Private": false,
        "Required": true,
        "Editable": false
    }}},{id: "1", Name: "Addresses", Tags: { "DisplayName": {
        "Name": "DisplayName",
        "Value": "Addresses",
        "Private": false,
        "Required": true,
        "Editable": false
    }}}]);

    useLayoutEffect(() => {
        setUserId(getInfo("UserID"));
        let defaultSP = getInfo('DefaultServiceProvider');
        if(defaultSP) {
            if (spIds.findIndex((v) => v === defaultSP) === -1) {
                spIds.push(defaultSP)
                updateTemplates(defaultSP);
            }
        }
    },[]);

    const fetchRequests = (shares) => {
        shares.forEach((shr) => {
            if(shr.tags?.RequestId?.Value) {
                GetRequestDetails(shr.tags?.RequestId?.Value).then(c =>{
                        setRequests((reqs) => ({...reqs, [c.id]: c}));
                })
            }
        })
    }

    const updateTemplates = (spid) => {
        GetTemplatesByServiceProviderID(spid).then((templateIdsArr) => {
            templateIdsArr.forEach((id) => {
                GetTemplateByID(id).then((template) => {
                    setTemplates((prevTemplates) => {
                      const exists = prevTemplates.some((t) => t.id === template.id);                    
                      return exists ? prevTemplates : [...prevTemplates, template];
                    });
                }).catch(err => console.log('Error fetching templates for spid ', spid, err));
            })
        }).catch(err => console.log('Error fetching templates for spid ', spid, err));
    }

    useLayoutEffect(() => {

        GetAccounts().then((response) => {
            if (Object.keys(response).length === 0) if (state !== 2) setState(1);
            Object.keys(response).forEach((key, index) => {
                GetAccount(key).then((accDetails) => {
                    if (Object.keys(accDetails.ServiceProviders).length === 0 && Object.keys(accDetails.Beneficiaries).length === 0) if (state !== 2) setState(1);
                    Object.keys(accDetails.Beneficiaries).forEach((k, i) => {
                       
                        GetBeneficiary(k).then((benDetails) => {
                            if (state !== 2) setState(1);
                            (
                                setBeneficiaryList((benList) => ([...benList, benDetails])))
                        }).catch(e => {
                            console.log(e);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                            setState(2);
                        })

                        GetSharesWith(k).then((share) => {
                            if (share.length > 0) {
                                fetchRequests(share);

                                setSharesBen((sharesBen) => ({ ...sharesBen, [share[0].beneficiaryID]: share }));
                                Promise.all(
                                    share.filter(d => d.securedcontentID === "" && d.streamID === "").map(async (el) => {
                                        try {
                                            const benid = el.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? el.serviceProviderID : el.beneficiaryID;
                                            var result = await GetAddress(el.addressID, benid, el.token, el.individualID);
                                            return result;

                                        } catch (err) {
                                            console.error("Error fetching addresses:", err);
                                            setShowAlert(true);
                                            setAlertText("Error fetching data");
                                        }
                                    })
                                ).then((addrs) => {
                                    setAddresses((addresses) => [...addresses, ...addrs]);
                                    if (state !== 2) setState(1);
                                }).catch((e) => {
                                    console.log(e);
                                    setShowAlert(true);
                                    setAlertText("Error fetching data");
                                    setState(2);
                                });
                                Promise.all(
                                    share.filter(d => d.securedcontentID !== "" && d.streamID === "").map(async (el) => {
                                        try {
                                            if (spIds.findIndex((v) => v === el.serviceProviderID) === -1) {
                                                spIds.push(el.serviceProviderID)
                                                updateTemplates(el.serviceProviderID);
                                            }
                                            const benid = el.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? el.serviceProviderID : el.beneficiaryID;
                                            var result = await GetSharedSecuredContent(el.securedcontentID, el.token, benid, el.individualID);
                                            return result;
                                        } catch (err) {
                                            console.error("Error fetching secured content:", err);
                                            setShowAlert(true);
                                            setAlertText("Error fetching data");
                                        }
                                    })
                                ).then((content) => {
                                    setSecuredContents((securedContents) => [...securedContents, ...content]);
                                    if (state !== 2) setState(1)
                                }).catch((e) => {
                                    console.log(e);
                                    setShowAlert(true);
                                    setAlertText("Error fetching data");
                                    setState(2);
                                });
                                Promise.all(
                                    share.filter(d => d.securedcontentID === "" && d.streamID !== "" ).map(async (el) => {
                                        try {
                                            const benid = el.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? el.serviceProviderID : el.beneficiaryID;
                                            var result = await GetSharedStream(el.streamID, el.token, benid, el.individualID);
                                            return result;
                                        } catch (err) {
                                            console.error("Error fetching secured content:", err);
                                            setShowAlert(true);
                                            setAlertText("Error fetching data");
                                        }
                                    })
                                ).then((streams) => {
                                    setStreams((prev) => [...prev, ...streams]);
                                    if (state !== 2) setState(1)
                                }).catch((e) => {
                                    console.log(e);
                                    setShowAlert(true);
                                    setAlertText("Error fetching data");
                                    setState(2);
                                });

                            }
                        }).catch((e) => {
                            console.log(e);
                            setShowAlert(true);
                            setAlertText("Error fetching data");
                            setState(2);
                        })
                    });


                    Object.keys(accDetails.ServiceProviders).forEach((k, i) => {
                        if (spIds.findIndex((v) => v ===k) === -1) {
                            spIds.push(k)
                            updateTemplates(k);
                        }
                            GetServiceProvider(k).then((spDetails) => {
                                if (state !== 2) setState(1);
                                setServiceProviderList((serviceProviderList) => ({ ...serviceProviderList, [spDetails.id]: spDetails }));
                            }).catch(e => {
                                console.log(e);
                                setShowAlert(true);
                                setAlertText("Error fetching data");
                                setState(2);
                            })
                            GetSharesWithServiceProvider(k).then((share) => {
                                if (share.length > 0) {
                                    fetchRequests(share);
                                    let bens = share.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") !== 0);
                                    bens.forEach((b,i) => {
                                        if(b.tags?.RequestId?.Value){
                                            GetRequestDetails(b.tags?.RequestId?.Value).then(c =>{
                                                let benRef = c.tags?.beneficiaryReference?.Value;
                                                if(benRef && benRef[0] === b.beneficiaryID) {
                                                    setRefBenAcceptedSpIds((refBenAcceptedSpIds) => ([...refBenAcceptedSpIds, b.serviceProviderID + b.beneficiaryID]));
                                                }
                                            })
                                        }
                                        GetBeneficiary(b.beneficiaryID).then((benDetails) => {
                                            if (state !== 2) setState(1);
                                            setBeneficiaryList((benList) => ([...benList, benDetails]))
                                        }).catch(e => {
                                        })
                                    })
                                    const sharewithben0 = share.filter((d) => d.beneficiaryID?.localeCompare("00000000-0000-0000-0000-000000000000") === 0);
                                    let filteredShares = sharewithben0.filter((val) => bens.findIndex(v => v.serviceProviderID === val.serviceProviderID && v.addressID === val.addressID && v.streamID === val.streamID && v.securedcontentID === val.securedcontentID) === -1  )
                                    filteredShares = [...filteredShares, ...bens];
                                    setShares((shares) => ({ ...shares, [share[0].serviceProviderID]: filteredShares }));
                                    Promise.all(
                                        //while fetching data we should only consider the records with primary token. 
                                        share.filter(d => d.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 && d.securedcontentID === "" && d.streamID === "").map(async (el) => {
                                            try {
                                                var result = await GetAddress(el.addressID, el.serviceProviderID, el.token, el.individualID);
                                                return result;

                                            } catch (err) {
                                                console.error("Error fetching addresses:", err);
                                                setShowAlert(true);
                                                setAlertText("Error fetching data");
                                            }
                                        })
                                    ).then((addrs) => {
                                        setAddresses((addresses) => [...addresses, ...addrs]);
                                        if (state !== 2) setState(1);
                                    }).catch((e) => {
                                        console.log(e);
                                        setShowAlert(true);
                                        setAlertText("Error fetching data");
                                        setState(2);
                                    });
                                    Promise.all(
                                        //while fetching data we should only consider the records with primary token. 
                                        share.filter(d => d.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 && d.securedcontentID !== "" && d.streamID === "").map(async (el) => {
                                            try {
                                                var result = await GetSharedSecuredContent(el.securedcontentID, el.token, el.serviceProviderID, el.individualID);                                          
                                                return result;
                                            } catch (err) {
                                                console.error("Error fetching secured content:", err);
                                                setShowAlert(true);
                                                setAlertText("Error fetching data");
                                            }
                                        })
                                    ).then((content) => {
                                        setSecuredContents((securedContents) => [...securedContents, ...content]);
                                        if (state !== 2) setState(1);
                                    }).catch((e) => {
                                        console.log(e);
                                        setShowAlert(true);
                                        setAlertText("Error fetching data");
                                        setState(2);
                                    });

                                    Promise.all(
                                        //while fetching data we should only consider the records with primary token. 
                                        share.filter(d => d.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 && d.securedcontentID === "" && d.streamID !== "").map(async (el) => {
                                            try {
                                                var result = await GetSharedStream(el.streamID, el.token, el.serviceProviderID, el.individualID);
                                                return result;
                                            } catch (err) {
                                                console.error("Error fetching secured content:", err);
                                                setShowAlert(true);
                                                setAlertText("Error fetching data");
                                            }
                                        })
                                    ).then((streams) => {
                                        setStreams((prev) => [...prev, ...streams]);
                                        if (state !== 2) setState(1);
                                    }).catch((e) => {
                                        console.log(e);
                                        setShowAlert(true);
                                        setAlertText("Error fetching data");
                                        setState(2);
                                    });
                                }

                            }).catch(e => {
                                console.log(e);
                                setShowAlert(true);
                                setAlertText("Error fetching data");
                                setState(2);
                            })
                    })
                })
            })
        }).catch((error) => {
            console.error("Error fetching accounts:", error);
            setShowAlert(true);
            setAlertText("Error fetching data from server. Please try again!");
            setState(2);
        });
    }, []);

    const getFilteredShares = (shareArr) => {
        return shareArr.filter((s) => {
            const content = s.securedcontentID? contentMap[s.securedcontentID]: null;

            const stream = s.streamID? streamMap[s.streamID]: null;

            const address = s.addressID? addressMap[s.addressID] : null;

            const serviceProvider = serviceProviderList[s.serviceProviderID];
            const beneficiary = beneficiaryMap[s.beneficiaryID];
            return matchesFilters({
                share: s,
                content,
                stream,
                address,
                filters,
                templates,
                serviceProvider,
                beneficiary,
            });
        });
    };
    const groupShares = (shareArr, selectedGroup) => {
        const grouped = {};

        shareArr.forEach((s) => {
            const req = requests[s.tags?.RequestId?.Value];

            const from =
                decodeURIComponent(
                    req?.tags?.UserEmail ? req.tags.UserEmail.Value : ""
                ) || "Unknown";

            let groupKey = "default";

            if (selectedGroup === "sharedBy") {
                groupKey = from;
            }

            if (selectedGroup === "contentType") {
                if (s.securedcontentID) {
                    const content = s.securedcontentID? contentMap[s.securedcontentID]: null;
                    if (content) {
                        const template = FirstMatchedTemplate(content, templates);
                        groupKey =
                            template?.Tags?.DisplayName?.Value ||
                            template?.Name ||
                            "";
                    }
                } else if (s.streamID) {
                    groupKey = "Documents";
                } else if (s.addressID) {
                    groupKey = "Addresses";
                }
            }

            if(selectedGroup === "contentID") {
                if (s.securedcontentID) {
                    const content = s.securedcontentID? contentMap[s.securedcontentID]: null;
                    if (content) {
                        const tpl = ProcessTemplate(FirstMatchedTemplate(content, templates));
                        const name = content.tags[tpl?.contentNameTag]?.Value;
                        groupKey = (name? name: "Untitled") + "[" + s.securedcontentID + "]";
                    }
                } else if (s.streamID) {
                    const stream = streamMap[s.streamID];
                    const name = stream?.tags?.Name?.Value;
                    groupKey = (name ? name : "Untitled") + "[" + s.streamID + "]";
                } else if (s.addressID) {
                    const address = addressMap[s.addressID];
                    const name = address?.tags?.atag?.Name
                    groupKey = (name ? name: "Untitled") + "[" + s.addressID + "]";
                }
            }

            if (!grouped[groupKey]) {
                grouped[groupKey] = [];
            }

            grouped[groupKey].push(s);
        });

        return grouped;
    };
    
    const renderSection = (title,shareArr,groupState,setGroupState,sectionKey,grouped, filtered) => {
        const selectedGroup = groupState[sectionKey] || "none";
        
        return (
            <div key={`${sectionKey}-${title}`}>
                {/* Header */}
                <div className="flex justify-between items-center p-2">
                    <h1 className="bold-text-input">{title}</h1>

                    <select key={`group_${selectedGroup}`}
                        value={selectedGroup}
                        onChange={(e) =>
                            setGroupState((prev) => ({
                                ...prev,
                                [sectionKey]: e.target.value,
                            }))
                        }
                        className="bg-gray-800 text-gray-200 text-sm px-3 py-1 rounded-md border border-gray-700"
                    >
                        <option value="none">Group by: None</option>
                        <option value="sharedBy">Group by: Shared by</option>
                        <option value="contentType">Group by: Content type</option>
                        <option value="contentID">Group by: Content/Docs</option>
                    </select>
                </div>

                <div className="bg-gray">
                    <div className=" max-w-full">
                        {filtered.length === 0 ? (
                            <div key="no data" className="text-gray-400 px-3">
                                {shareArr.length === 0
                                    ? "No data present."
                                    : "No match found."}
                            </div>
                        ) : selectedGroup === "none" ? (
                            <div key="no selection" className="flex flex-wrap gap-2 px-3">
                                {grouped.default.map((s) => renderCard(s))}
                            </div>
                        ) : (
                            Object.entries(grouped).map(([groupName, items]) => (
                                <div key={`${groupName}-${sectionKey}-${title}`} className="mb-6 rounded-lg bg-gray-950 border border-gray-800">

                                    <div className="flex items-center justify-start gap-3 px-4 py-2 border-b border-gray-700">
                                        <h3 className="text-sm font-medium tracking-wider text-gray-300">
                                            {groupName}
                                        </h3>
                                        <span className="bg-gray-800 border border-gray-700 text-white text-xs font-semibold px-2 py-1 rounded-full">
                                            {items.length}
                                        </span>
                                    </div>
                                    <div className="flex flex-wrap gap-2 px-3">
                                        {items.map((s) => renderCard(s))}
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        );
    };

    const renderCard = (s) => {
        var bens = refBenSet.has(s.serviceProviderID + s.beneficiaryID) ? [s] : [];
        var from = "Individual ID:" + s.individualID
        var to = ""

        var cfromJRN = ""
        var ctoJRN = "jrn:individual: " + s.individualID
       
        if (s.beneficiaryType === "serviceprovider") {
        		cfromJRN = "jrn:serviceprovider:" + s.beneficiaryID
		} else if (s.beneficiaryType === "beneficiary") {
			cfromJRN = "jrn:beneficiary:" + s.beneficiaryID
		} else if (s.beneficiaryType === "individual")  {
			cfromJRN = "jrn:individual:" + s.beneficiaryID
		}

        let req = requests[s.tags?.RequestId?.Value]
        if (req) {
            from = decodeURIComponent(
                req.tags.UserEmail ? req.tags.UserEmail.Value : ""
            );
            to = decodeURIComponent(
                req.tags.SharedWithEmail ? req.tags.SharedWithEmail.Value : ""
            );

        }

        const content = s.securedcontentID? contentMap[s.securedcontentID]: null;

        const stream = s.streamID? streamMap[s.streamID]: null;

        const address = s.addressID? addressMap[s.addressID]: null;
        
        const benid = s.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? null : s.beneficiaryID;

        if (s.securedcontentID) {
            if (content) {
                let matchedtemplate = FirstMatchedTemplate(content, templates);
                return <ContentBox canConfirm={true} fromJRN={cfromJRN} toJRN={ctoJRN} confirmationFrom={cfromJRN} token={s.token} template={matchedtemplate} created={s?.created ? s.created : ""} updated={s?.updated ? s.updated : ""} content={content} from={from} to={to} requestId={s?.tags?.RequestId?.Value} benList={beneficiaryList} ben={bens} isBusiness={true} serviceProviderId={s.serviceProviderID} benId={benid} />;
            } return <></>
        } else if (s.streamID) {
            if (stream) {
                return <StreamBox canConfirm={true} fromJRN={cfromJRN} toJRN={ctoJRN} confirmationFrom={cfromJRN} token={s.token} beneficiaryID={s.beneficiaryID.localeCompare("00000000-0000-0000-0000-000000000000") === 0 ? s.serviceProviderID : s.beneficiaryID} individualID={s.individualID} created={s?.created ? s.created : ""} updated={s?.updated ? s.updated : ""} serviceProviderId={s.serviceProviderID} benId={benid} stream={stream} from={from} to={to} requestId={s?.tags?.RequestId?.Value} benList={beneficiaryList} ben={bens} isBusiness={true} />;
            } return <></>
        } else {
            return <AddressBox canConfirm={true} fromJRN={cfromJRN} toJRN={ctoJRN} confirmationFrom={cfromJRN} token={s.token} created={s?.created ? s.created : ""} updated={s?.updated ? s.updated : ""} from={from} to={to} address={address} requestId={s?.tags?.RequestId?.Value} benList={beneficiaryList} ben={bens} isBusiness={true} serviceProviderId={s.serviceProviderID} benId={benid} />;
        }

    }

    const showSPs = () => {
        if (Object.keys(shares).length === 0) return null;

        return Object.keys(shares).map((k) => {
            const selectedGroup = groupBySP[k] || "none";
            const filtered = getFilteredShares(shares[k]);
            const grouped = selectedGroup === "none"? { default: filtered }: groupShares(filtered, selectedGroup);
            return renderSection(
                `Shared with ${serviceProviderList[k]?.tags?.name?.Value} (Service Provider)`,
                shares[k],
                groupBySP,
                setGroupBySP,
                k,
                grouped,
                filtered
            )
        }
        );
    };

    const showBens = () => {
        if (Object.keys(sharesBen).length === 0) return null;

        return Object.keys(sharesBen).map((k) => {
            const selectedGroup = groupByBen[k] || "none";
            const filtered = getFilteredShares(sharesBen[k]);
            const grouped = selectedGroup === "none"? { default: filtered }: groupShares(filtered, selectedGroup);
            
            return renderSection(
                `Shared with ${beneficiaryMap[k]?.tags?.name?.Value} (Beneficiary)`,
                sharesBen[k],
                groupByBen,
                setGroupByBen,
                k,
                grouped,
                filtered
            )
        }
        );
    };
    useEffect(() => {
        try {
            localStorage.setItem(
                document.location.hostname + '.shares.groupBySP',
                JSON.stringify(groupBySP)
            );
        } catch (e) {
            console.error("Failed to save groupBySP to localStorage", e);
        }
    }, [groupBySP]);
    useEffect(() => {
        try {
            localStorage.setItem(
                document.location.hostname + '.shares.groupByBen',
                JSON.stringify(groupByBen)
            );
        } catch (e) {
            console.error("Failed to save groupByBen to localStorage", e);
        }
    }, [groupByBen]);

    const contentTypeOptions = useMemo(() => {
            return templates
                .slice()
                .sort((a, b) =>
                    (a?.Tags?.DisplayName?.Value || a?.Name)
                        ?.toLowerCase()
                        .localeCompare(
                            (b?.Tags?.DisplayName?.Value || b?.Name)?.toLowerCase()
                        )
                )
                .map((t) => ({
                    value: t.Name,
                    label: t?.Tags?.DisplayName?.Value || t.Name,
                    id: t.id,
                }));
        }, [templates]);
    const handleContentTypeChange = (value) => {
        setFilters((prev) => ({
            ...prev,
            contentType: value,
        }));
    };
        const sharedWithSource = useMemo(() => {
            const spEntities = Object.entries(serviceProviderList).map(([id, sp]) => ({
                id,
                label: sp?.tags?.name?.Value || "Unknown Service Provider",
                type: "sp",
            }));
    
            const benEntities = beneficiaryList?.map((ben) => ({
                id: ben.id,
                label: ben?.tags?.name?.Value || "Unknown Beneficiary",
                type: "ben",
            }));
    
            return [...spEntities, ...benEntities];
        }, [serviceProviderList, beneficiaryList]);
    
        useEffect(() => {
            if (!sharedWithInput) {
                setSharedWithSuggestions([]);
                return;
            }
    
            const q = sharedWithInput.toLowerCase();
    
            const matches = sharedWithSource
                .filter((e) => e.label.toLowerCase().includes(q))
                .slice(0, 8); // limit suggestions
    
            setSharedWithSuggestions(matches);
        }, [sharedWithInput, sharedWithSource]);
    
        const handleAddSharedWith = (entity) => {
            setFilters((prev) => ({
                ...prev,
                sharedWith: [...prev.sharedWith, entity],
                sharedWithText: "",
            }));
            setSharedWithInput("");
            setSharedWithSuggestions([]);
        };
    
        const handleRemoveSharedWith = (id) => {
            setFilters((prev) => {
                const remaining = prev.sharedWith.filter((e) => e.id !== id);
    
                return {
                    ...prev,
                    sharedWith: remaining,
                    sharedWithText: remaining.length === 0 ? prev.sharedWithText : "",
                };
            });
        };

    return userId ? (

        <div className="px-1 md:px-4 py-3 max-w-screen-xl mx-auto items-center">
            <h1 className="bold-text-input">Secured Content Shares</h1>
            <div
                class="  bg-blue-100 border-blue-500 text-blue-700 px-2 py-2 relative"
                role="alert"
                style={{ display: showAlert ? "block" : "none" }}
            >                <button className="absolute top-2 right-1 text-lg font-normal text-gray-700 -translate-x-2 " onClick={()=> {setShowAlert(false)}}>X</button>
                <span class="text-sm">{alertText} </span>
            </div>
            {
                state === 0 ? "Loading..." : Object.keys(shares).length === 0 && Object.keys(sharesBen).length === 0 ? (<div className="w-full h-full p-2 flex items-start justify-start text-blue-300">
                    <p className="text-start">It looks like you don't have any shared content yet. Keep adding and updating your profile so people can start sharing with you!</p>
                </div>) : <> <div className="p-5"><ShareFiltersBar
                                        filters={filters}
                                        contentTypes={contentTypeOptions}
                
                                        sharedWithInput={sharedWithInput}
                                        sharedWithSuggestions={sharedWithSuggestions}
                
                                        onContentTypeChange={handleContentTypeChange}
                                        onSearchTextChange={(val) =>
                                            setFilters((prev) => ({ ...prev, searchText: val }))
                                        }
                
                                        onSharedWithInputChange={(val) => {
                                            setSharedWithInput(val);
                                            setFilters((prev) => ({
                                                ...prev,
                                                sharedWithText: val.trim(),
                                            }));
                                        }}
                                        onAddSharedWith={handleAddSharedWith}
                                        onRemoveSharedWith={handleRemoveSharedWith}
                                    /></div> {showSPs()} {showBens()}</>

            }
        </div>

    ) : (
        <Login />
    );
};


export default ServiceProviderShares;
